// extracted by mini-css-extract-plugin
export default {"th":"TableSort_th__Smox2","control":"TableSort_control__8FRDU","icon":"TableSort_icon__M+BhK","sticky":"TableSort_sticky__Fi5Yl","eventid":"TableSort_eventid__S3fi2"};